// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"b71e9aa9","519":"0b69d018","627":"e5176cb6","774":"003684c5","787":"6279064f","819":"4961ea39","858":"0eb236c3","910":"975e4be2"}[chunkId] + ".chunk.js";
};